import { useState, useEffect } from 'react';
import Form from 'react-bootstrap/Form';
import { Col } from 'react-bootstrap';
import PaymentMethodSelector from '../../../molecules/PaymentMethodSelector/view';
import { getReceiptTypes } from '../../../../usecases/receipts-usecase';
import { dispatchCustomEvent } from '../../../../utils/dispatch';

/**
 * Formulario para crear recibos de caja generales.
 * 
 * @param {Object} props
 * @param {Object} props.data - Datos del formulario
 * @param {Object} props.errors - Errores de validación
 * @param {Function} props.onChange - Callback para cambios en el formulario
 */
function GeneralReceiptForm({ data, errors, onChange }) {
    const [receiptTypes, setReceiptTypes] = useState([]);

    useEffect(() => {
        fetchReceiptTypes();
    }, []);

    async function fetchReceiptTypes() {
        try {
            const result = await getReceiptTypes(1, 100);
            setReceiptTypes(result.data);
        } catch (err) {
            console.error("Error fetching receipt types:", err);
            dispatchCustomEvent("popup", {
                message: "Error al cargar tipos de recibo",
                type: "error"
            });
        }
    }

    function handleChange(e) {
        const { id, value } = e.target;
        const key = id.replace("receipt-", "");
        onChange({ ...data, [key]: value });
    }

    function handlePaymentMethodsChange(methods) {
        onChange({ ...data, payment_methods: methods });
    }

    return (
        <>
            <Form.Group as={Col} controlId="receipt-description" className="mb-3">
                <Form.Label>Descripción</Form.Label>
                <Form.Control
                    type="text"
                    placeholder="Ingresa la descripción"
                    onChange={handleChange}
                    value={data.description || ''}
                    isInvalid={errors.description}
                />
                <Form.Control.Feedback type="invalid">
                    La descripción es obligatoria.
                </Form.Control.Feedback>
            </Form.Group>

            <Form.Group as={Col} controlId="receipt-receipt_type_id" className="mb-3">
                <Form.Label>Tipo de Recibo</Form.Label>
                <Form.Select
                    name="receipt_type_id"
                    onChange={handleChange}
                    value={data.receipt_type_id || ''}
                    isInvalid={errors.receipt_type_id}
                >
                    <option value="">Selecciona un tipo de recibo</option>
                    {receiptTypes?.map(type => (
                        <option key={type.id} value={type.id}>
                            {type.name}
                        </option>
                    ))}
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                    El tipo de recibo es obligatorio.
                </Form.Control.Feedback>
            </Form.Group>

            <Form.Group as={Col} controlId="receipt-payment-methods" className="mt-3">
                <PaymentMethodSelector
                    selectedMethods={data.payment_methods || []}
                    onSelectMethod={handlePaymentMethodsChange}
                    onAmountChange={handlePaymentMethodsChange}
                    onRemoveMethod={handlePaymentMethodsChange}
                />
            </Form.Group>
        </>
    );
}

export default GeneralReceiptForm;
